import axios from './request'
import config from './config'
import nanxunCab from './cab_report'
import tyCab from './tyCab_report'
const module = '/site/business'
const moduleBI = '/store/bi'
const api = {
  // 获取微信jssdk配置参数
  getWxInfo: data => {
    return axios({
      baseURL: config.FEE_HOST,
      method: 'post',
      url: '/sign/config',
      data,
      transformRequest: [
        (data, headers) => {
          delete headers['session-id']
          return JSON.stringify(data)
        }
      ]
    })
  },
  // 获取地区
  getAreaList: areaId => {
    return axios({
      url: `/basics/v1.0/area/area/${areaId}/town/list`,
      method: 'get',
      loadingDisable: true
    })
  },
  // 获取寄件方默认地址
  getSenderDefaultAddress: () => {
    return axios({
      url: `${module}/v1/send/express/user/address/sender/default`,
      method: 'get',
      data: {}
    })
  },
  // 获取用户地址
  getUserAddress: params => {
    return axios({
      url: `${module}/v1/send/express/user/address`,
      method: 'get',
      params: params
    })
  },
  // 获取用户地址列表
  getUserAddressList: params => {
    return axios({
      url: `${module}/v1/send/express/user/address/list`,
      method: 'post',
      data: params
    })
  },
  // 七牛上传图片token
  getQiniuToken: () => {
    return axios({
      url: '/basics/v1.0/qiniu/token',
      method: 'get',
      loadingDisable: true
    })
  },
  // 实名认证
  realName: params => {
    return axios({
      url: `${module}/v1/send/express/user_realname/create`,
      method: 'post',
      data: params,
      loadingDisable: true
    })
  },
  // 新增用户地址
  addUserAddress: params => {
    return axios({
      url: `${module}/v1/send/express/user/address/create`,
      method: 'post',
      data: params
    })
  },
  // 修改用户地址
  editUserAddress: params => {
    return axios({
      url: `${module}/v1/send/express/user/address/modify`,
      method: 'post',
      data: params
    })
  },
  // 修改寄件人地址默认表示
  changeSenderDefault: params => {
    return axios({
      url: `${module}/v1/send/express/user/address/sender/default/modify`,
      method: 'post',
      params: params
    })
  },
  // 删除用户地址
  deleteUserAddress: params => {
    return axios({
      url: `${module}/v1/send/express/user/address/delete`,
      method: 'post',
      params: params
    })
  },
  // 获取最近驿站列表
  getPostStageList: params => {
    return axios({
      url: `${module}/v1/send/express/site_location/recently/list`,
      method: 'post',
      data: params
    })
  },
  // 获取站点快递价格列表
  getExpressList: params => {
    return axios({
      url: `${module}/v1/send/express/site/express_company/price/list`,
      method: 'get',
      params: params
    })
  },
  // 获取寄件下单token
  getOrderToken: () => {
    return axios({
      url: `${module}/v1/send/express/order/token`,
      method: 'post'
    })
  },
  // 创建订单
  createOrder: (params, header) => {
    return axios({
      url: `${module}/v1/send/express/order/create`,
      method: 'post',
      data: params,
      headers: header
    })
  },
  // 查询订单列表
  getUserOrderList: params => {
    return axios({
      url: `${module}/v1/send/express/user/order/list`,
      method: 'post',
      data: params
    })
  },
  // 查询订单详情
  getUserOrderDetail: params => {
    return axios({
      url: `${module}/v1/send/express/user/order/detail`,
      method: 'get',
      params: params
    })
  },
  // 取消寄件订单
  cancelOrder: params => {
    return axios({
      url: `${module}/v1/send/express/order/user_cancel`,
      method: 'post',
      data: params
    })
  },
  // 删除寄件订单
  deleteOrder: params => {
    return axios({
      url: `${module}/v1/send/express/order/user_delete`,
      method: 'post',
      params: params
    })
  },
  // 获取地域信息
  getAreaInfo: adCode => {
    return axios({
      url: `basics/v1.0/area/areainfo/${adCode}`,
      method: 'get'
    })
  },
  // 微信预支付下单
  wx_prepayment: params => {
    return axios({
      url: `${module}/v1/send/express/wechatpay/user/prepayment`,
      method: 'post',
      data: params
    })
  },
  // 查询可一键取件快件列表
  oneKeyPickUpList: params => {
    return axios({
      url: `${module}/v1/site/mp/user/express/list`,
      method: 'post',
      data: params
    })
  },
  // 一键取件
  oneKeyPickUp: params => {
    return axios({
      url: `${module}/v1/site/mp/apply/pick/express`,
      method: 'post',
      data: params,
      timeout: 0
    })
  },
  // 展开更多
  expandMoreApi: params => {
    return axios({
      url: `${module}/v1/site/express/filter`,
      method: 'post',
      data: params
    })
  },
  // 获取户址列表
  getHousingList: params => {
    return axios({
      url: `/cabinet-ims/housing/apartment/${params}`,
      method: 'get'
    })
  },
  // 修改信包密码 发送验证码
  editLetterPwdSendMsg: params => {
    return axios({
      baseURL: config.FEE_HOST,
      url: '/sendLetterBoxMsg',
      method: 'post',
      params: params,
      transformRequest: [
        (params, headers) => {
          delete headers['session-id']
          // return JSON.stringify(params)
        }
      ]
    })
  },
  // 修改信包密码
  editLetterPwd: params => {
    return axios({
      url: '/cabinet-ims/housing/apartment/password',
      method: 'put',
      data: params
    })
  },

  // 获取运营组列表
  getOperationList() {
    return axios({
      url: '/store/ims/site_manager/getOperationList',
      method: 'post'
    })
  },
  // 获取地区列表
  getCityByOperation: params => {
    return axios({
      url: `${moduleBI}/statistic/area/name`,
      method: 'get',
      params: params
    })
  },
  getSiteList(params) {
    return axios({
      url: `${moduleBI}/statistic/express/chart/siteInfo`,
      method: 'get',
      params: params
    })
  },
  // 数据图表入出库数据统计（按日期统计）
  getChartDate: params => {
    return axios({
      url: `${moduleBI}/statistic/express/chart/dateV2`,
      method: 'post',
      data: params
    })
  },
  // 数据图表入出库数据统计（按快递品牌统计）
  getChartCompany: params => {
    return axios({
      url: `${moduleBI}/statistic/express/chart/companyV2`,
      method: 'post',
      data: params
    })
  },
  // 获取出入库数据总计
  getInOutAbData: params => {
    return axios({
      url: `${moduleBI}/statistic/express/inOutAbStoreV2`,
      method: 'post',
      data: params
    })
  },
  // 获取注册驿站的验证码
  getSmsCode: params => {
    return axios({
      url: `${module}/site/regist/getCheckCode`,
      method: 'post',
      data: params
    })
  },
  // 获取无入库站点
  getWithoutInstoreSite: params => {
    return axios({
      url: `${moduleBI}/statistic/without/instoreSite`,
      method: 'get',
      params
    })
  },
  // 获取站点入库品牌明细
  getExpressCompanyDetail: params => {
    return axios({
      url: `${moduleBI}/statistic/express/company/detail`,
      method: 'get',
      params
    })
  },
  getYYExpressInOut: params => {
    return axios({
      url: `${moduleBI}/yy/statistic/express/inout`,
      method: 'get',
      params
    })
  },
  // 南浔区域柜机接口
  nanxun: nanxunCab,
  tyCab: tyCab
}
export default api
